module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/get-connected/get-connected-sent-image.png?ebe677c371d99ec6d816c9f9ead3877d";